const DEVELOPMENT_HOST_PATTERN = /(^localhost$)|(^|\.)dev\.hardware\.shop\.it\.a2z\.com$/;

export const isDevelopmentEnvironment = (hostname: string = window.location.hostname): boolean =>
  DEVELOPMENT_HOST_PATTERN.test(hostname);
